import axios from 'axios';
import Qs from 'qs';
import store from '../store/store';
import commonFunc from '../common/commonFunction';
import i18n from '../i18n/i18n';
import moment from 'moment';

// Danh sách đối tượng cần xử lý cancel request
let cancelRequests = [];

/**
 * Lớp này dùng để thao tác với restful
 */
class AxiosHttpClient {
	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async postAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await this.requestAsync(
			config,
			POST,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async putAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await this.requestAsync(
			config,
			PUT,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async deleteAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await this.requestAsync(
			config,
			DELETE,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async getAsync(
		config,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		return await this.requestAsync(
			config,
			GET,
			isShowLoading,
			isCancelRequest,
			contenType
		);
	}

	/**
	 * config: AxiosRequestConfig
	 * @param config: {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 * @param method: POST, PUT, GET, DELTE
	 * @param isShowLoading: có cho loading hay không, hiển thị loading cho người dùng
	 * @param isCancelRequest: có cho phép hủy request cùng url và method hay không
	 * @param contenType: application/json, application/x-www-form-urlencoded, multipart/form-data
	 */
	async requestAsync(
		config,
		method,
		isShowLoading = false,
		isCancelRequest = true,
		contenType = ApplicationJson
	) {
		try {
			commonFunc.infoLogging(`requestAsync::url::${config.url}`);

			// Cập nhật các tham số của headers
			this._processHeaders(config);

			// Cập nhật data
			this._processDataOrParams(config, method, contenType);

			// Lấy key trong danh sách hủy request
			let key = this._getKey(config);

			// Thêm cancelrequest vào danh sách hủy
			let cancelRequest = this._addCancelRequest(
				config,
				key,
				isCancelRequest
			);

			// Hiển thị loading
			this._setLoading(isShowLoading, true);

			// Thực hiện gọi service
			let result = await axios(config);

			// Log kết quả
			commonFunc.infoLogging('requestAsync::result::begin');
			commonFunc.infoLogging(result);
			commonFunc.infoLogging('requestAsync::result::end');

			// Ẩn loading
			this._setLoading(isShowLoading, false);

			// Hủy request
			this._removeRequest(cancelRequest, 'finish');

			// Trả kết quả xử lý thành công
			if (result && result.data) {
				return result.data;
			}

			// Nếu lỗi có StatusCode >= 400
			if (result && result.Code) {
				return result;
			}

			// Trường hợp request bị hủy nên trả về empty dữ liệu
			return {
				Success: false,
				Data: null,
				Code: 0,
				Message: i18n.t('i18nCommon.CancelRequest'),
				MessageDev: '',
			};
		} catch (error) {
			// Log lỗi
			commonFunc.errorLogging('requestAsync::error::', error.response);

			// Ẩn loading
			this._setLoading(isShowLoading, false);

			// Trả kết quả lỗi
			return error.response && error.response.data
				? error.response.data
				: {
						Success: false,
						Data: null,
						Code: 0,
						Message: i18n.t('i18nCommon.CancelRequest'),
						MessageDev: ''
				  };
		}
	}

	/**
	 * config: AxiosRequestConfig
	 * Chi tiết các thông tin trong config
	 * @param {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 */
	_processDataOrParams(config, method, contenType = ApplicationJson) {
		if (!config) return;

		// Xử lý method
		config.method = method;

		// Xử lý tham số đối với phương thức GET, DELETE
		if (method == GET || method == DELETE) {
		}

		// Xử lý tham số đối với phương thức POST, PUT, kiểu form-url-encoded
		if ((method == POST || method == PUT) && contenType == FormUrlEncoded) {
			config.data = Qs.stringify(config.data || {});
		}

		// Xử lý tham số đối với phương thức POST, PUT, kiểu multipart
		if ((method == POST || method == PUT) && contenType == FormMultiPart) {
		}
	}

	/**
	 * config: AxiosRequestConfig
	 * Chi tiết các thông tin trong config
	 * @param {
	 * url?: string;
	 * method?: string;
	 * baseURL?: string;
	 * transformRequest?: AxiosTransformer | AxiosTransformer[];
	 * transformResponse?: AxiosTransformer | AxiosTransformer[];
	 * headers?: any;
	 * params?: any;
	 * paramsSerializer?: (params: any) => string;
	 * data?: any;
	 * timeout?: number;
	 * withCredentials?: boolean;
	 * adapter?: AxiosAdapter;
	 * auth?: AxiosBasicCredentials;
	 * responseType?: string;
	 * xsrfCookieName?: string;
	 * xsrfHeaderName?: string;
	 * onUploadProgress?: (progressEvent: any) => void;
	 * onDownloadProgress?: (progressEvent: any) => void;
	 * maxContentLength?: number;
	 * validateStatus?: (status: number) => boolean;
	 * maxRedirects?: number;
	 * httpAgent?: any;
	 * httpsAgent?: any;
	 * proxy?: AxiosProxyConfig | false;
	 * cancelToken?: CancelToken;
	 * }
	 */
	_processHeaders(config, contenType = ApplicationJson) {
		if (!config) return;

		// Lấy dữ liệu của headers
		let headers = config.headers || {};

		config.withCredentials = true;

		// Cập nhật Authorization
		if (store.state.auth) {
			headers[
				'Authorization'
			] = `${store.state.auth.tokenType} ${store.state.auth.mtaxAccessToken}`;
		}

		// Content type
		headers['Content-Type'] = contenType;

		// Client id truy cập vào hệ thống mtax
		headers['ClientId'] = window.__env.authConfig.client_id;

		// Mã số thuế làm việc
		if (store.state.company.companyInfo) {
			headers['TaxCode'] = store.state.company.companyInfo.TaxCode;
		}

		//Thông tin mã thiết thị
		headers['DeviceId'] = commonFunc.getDeviceId();

		// Cập nhật lại header
		config.headers = headers;
	}

	/**
	 * Lấy key để cancel request theo config
	 * @param config
	 */
	_getKey(config) {
		if (!config) return '';
		return `${config.url}_${config.method}`;
	}

	/**
	 * Hàm này cho phép hủy request
	 * @param cancelRequest
	 */
	_removeRequest(cancelRequest, from) {
		try {
			if (!cancelRequest) return;

			// Hủy request
			if (cancelRequest.Value) {
				cancelRequest.Value.cancel();
			}

			// Xóa giá trị trong danh sách chờ hủy
			cancelRequests = cancelRequests.filter((n) => {
				return (
					n.Key != cancelRequest.Key ||
					(n.Key == cancelRequest.Key && n.Time != cancelRequest.Time)
				);
			});
		} catch (ex) {
			commonFunc.errorLogging('_cancelRequest::error:', ex);
		}
	}

	/**
	 * Thêm vào danh sách hủy request
	 * @param config
	 * @param key
	 * @param isCancelRequest
	 */
	_addCancelRequest(config, key, isCancelRequest) {
		const me = this;
		try {
			//Lấy các request có key và cần hủy
			let requests = cancelRequests.filter(
				(n) => n.Key == key && n.IsCancelRequest == true
			);
			if (requests != null && requests.length > 0) {
				requests.forEach((request) =>
					this._removeRequest(request, 'add')
				);
			}

			// cancel token
			let cancelTokenSource = axios.CancelToken.source();

			// Cập nhật vào config
			config.cancelToken = cancelTokenSource.token;

			//Tạo yêu cầu hủy request
			let cancelRequest = {
				Key: key,
				Value: cancelTokenSource,
				Time: new Date().getTime(),
				IsCancelRequest: isCancelRequest,
			};

			// Thêm vào danh sách chờ hủy request
			cancelRequests.push(cancelRequest);

			//Trả về tham số cancel request
			return cancelRequest;
		} catch (ex) {
			commonFunc.errorLogging('_addCancelRequest::error::', ex);
		}

		return null;
	}

	/**
	 * Hàm này dùng để update trạng thái loading trong global state
	 * @param isShowLoading có cho loading hay không, hiển thị loading cho người dùng
	 * @param isLoading
	 */
	_setLoading(isShowLoading, isLoading) {
		if (isShowLoading) {
			if (isLoading) {
				commonFunc.mask();
			} else {
				commonFunc.unmask();
			}
		}
	}
}

// Instance của axios client
export default new AxiosHttpClient();

// Các method của http
export const POST = 'POST';
export const PUT = 'PUT';
export const DELETE = 'DELETE';
export const GET = 'GET';

// Content-type
export const ApplicationJson = 'application/json';
export const FormUrlEncoded = 'application/x-www-form-urlencoded';
export const FormMultiPart = 'multipart/form-data';
